const CookiesData = [
  {
    productname: "Cardamom Rava",
    productdescription:
      "Perfect evening tea snack companion, made with organic brown sugar, cashew almond powder and roasted rava",
  },
  {
    productname: "Salt",
    productdescription: "Baked to perfection with a slight tinge of salt",
  },
  {
    productname: "Spicy",
    productdescription:
      "Spice up your taste buds with our spicy millet cookies containing salt, authentic spices and signature masala",
  },
  {
    productname: "Oats",
    productdescription:
      "With crispy edges, soft & chewy centers, our oats cookies are tasty all around with the goodness of millet",
  },
  {
    productname: "Peanut",
    productdescription:
      "Crunchy peanut butter cookies right out of PSO oven, made from crushed peanuts and organic brown sugar",
  },
  {
    productname: "Coconut",
    productdescription:
      "Made with the grated coconuts and millet, our crunchy coconut cookies offer a unique flavor",
  },
  {
    productname: "Ragi",
    productdescription:
      "Signature soft ragi cookies made with whole wheat ragi flour, millet and flavored by cardamom",
  },
];
export default CookiesData;
